import { FunctionComponent } from "react"

import { ChildrenProps } from "@/types/props"

import { useForbidAuthedAgentRouteHook } from "./hook"

const ForbidAuthedAgentRoute: FunctionComponent<ChildrenProps> = ({
  children,
}) => {
  useForbidAuthedAgentRouteHook()

  return <>{children}</>
}

export default ForbidAuthedAgentRoute
